(function () {
    'use strict';

    angular.module('swif.framework')
    .filter('reverse', reverse)
    .filter('slice', slice)
    .filter('paginate', paginate)
    .filter('formatAddress', formatAddress)
    .filter('noBreak', noBreak)
    .factory('swifFilterService', swifFilterService);


    function reverse(){
        return function(items) {
            if (items === undefined) {
                return items;
            }
            return items.slice().reverse();
        };
    }

    function slice(){
        return function(arr, start, end) {
            return (arr || []).slice(start, end);
        };
    }

    function paginate(){
        return function (arr, curr, ppage) {
            return (arr || []).slice((curr-1)*ppage, (curr)*ppage);
        };
    }

    function formatAddress() {
        return function(string) {
            var addr = JSON.parse(string);
            var formatted = addr.number + ' ' + addr.street + ', ' + addr.postal_code + ' ' + addr.city;
            return formatted;
        }
    }

    // Replaces space by a non-breaking space
    function noBreak() {
        return function(text) {
            return text.replace(/ /g, '\u00a0');
        }
    }

    /**
     * @ngdoc service
     * @name swif.framework.swifFilterService
     * @description
     * Provide a service to manage filters sent to the server (aka domain)
     * Filters are object send to the backend along a query payload to limit the
     * results.
     *
     * the dataService provide the api responsible to create the filter objects
     * and serialize them in the request / parse from the request.
     *
     * This service provide
     *
     */
    function swifFilterService(dataService, userService, msgService, $location, collections){
        'ngInject';
        console.log('create swifFilterService');
        var service = {
            vocabularies: {
                date: [
                    {id: 'FIRSTDAYWEEK', name: 'First day of the week'},
                    {id: 'LASTDAYWEEK', name: 'Last day of the week'},
                    {id: 'FIRSTDAYMONTH', name: 'First day of the month'},
                    {id: 'LASTDAYMONTH', name: 'Last day of the month'},
                    {id: 'OVERMONTH', name: 'In one month'},
                    {id: 'OUTDATED', name: 'Today'}
                ]
            },
            operators: {
                date: [
                    {name: 'The', icon: '=', value: '='},
                    {name: 'Different from', icon: '!=', value: '!='},
                    {name: 'After', icon: '>', value: '>'},
                    {name: 'After or equal', icon: '>=', value: '>='},
                    {name: 'Before', icon: '<', value: '<'},
                    {name: 'Before or equal', icon: '<=', value: '<='},
                    {name: 'Is set', icon: '∃', value: 'is_set', hideValue: true},
                    {name: 'Is not set', icon: '∄', value: 'is_not_set', hideValue: true}
                ],
                multiselect: [
                    {name: 'Equal', icon: '=', value: 'in'},
                    {name: 'Diff', icon: '≠', value: 'not in'},
                    {name: 'Is set', icon: '∃', value: 'is_set', hideValue: true},
                    {name: 'Is not set', icon: '∄', value: 'is_not_set', hideValue: true}
                ],
                tree: [
                    {name: 'Equal', icon: '=', value: 'in'},
                    {name: 'Diff', icon: '≠', value: 'not in'},
                    {name: 'Is set', icon: '∃', value: 'is_set', hideValue: true},
                    {name: 'Is not set', icon: '∄', value: 'is_not_set', hideValue: true},
                    {name: 'Child of', icon: '\u2193', value: 'child_of'}
                ],
                number: [
                    {name: 'Equal', icon: '=', value: '='},
                    {name: 'Diff', icon: '≠', value: '!='},
                    {name: 'More than', icon: '>', value: '>'},
                    {name: 'More or equal than', icon: '>=', value: '>='},
                    {name: 'Less than', icon: '<', value: '<'},
                    {name: 'Less or equal than', icon: '<=', value: '<='}
                ],
                bool: [
                    {name: 'Equal', icon: '=', value: '='}
                ],
                isSetOrNot: [
                    {name: 'Is set', value: 'is_set'},
                    {name: 'Is not set', value: 'is_not_set'}
                ],
                text: [
                    {name: 'Equal', icon: '=', value: 'ilike'},
                    {name: 'Diff', icon: '≠', value: 'not ilike'},
                    {name: 'Is set', icon: '∃', value: 'is_set', hideValue: true},
                    {name: 'Is not set', icon: '∄', value: 'is_not_set', hideValue: true}
                ]
            },
            loadMyFilters: loadMyFilters,
            parseDomain: parseDomain,
            callbackMessage: callbackMessage,
            callback: callback,
            setCollectionFilter: setCollectionFilter,
            loadFilteredCollection: loadFilteredCollection
        };
        return service;

        /**
         * @ngdoc method
         * @name loadMyFilters
         * @methodOf swif.framework.swifFilterService
         * @description
         * get ir.filter from the server associated to the current user
         * @param {string} model ir_filter.model_id
         * @returns {promise} Array of ir.filter records
        **/
        function loadMyFilters(model) {
            var user = userService.getAuthenticatedUser();
            var filter = {};
            if (model) {
                dataService.addFilter(filter, 'model_id', '=', model);
            }
            if (user) {
                dataService.addFilter(filter, '|');
                dataService.addFilter(filter, 'user_id', '=', user.uid);
            }
            dataService.addFilter(filter, 'user_id', '=', false);
            return dataService.get('filter', undefined, filter);
        }

        /**
         * @ngdoc method
         * @name parseDomain
         * @methodOf swif.framework.swifFilterService
         * @description
         * When are from the server their domain are in sort of JSON
         * we need to clean it up
         * @param {object} filter {domain: []} or {domain: ''}
         * @returns {promise} domain as an array
        **/
        function parseDomain(filter) {
            var domain = filter.domain;
            if (_.isString(domain)) {
                domain = domain.replace(/'/g, '"');
                domain = domain.replace(/False/g, 'false').replace(/True/g, 'true');
                return JSON.parse(domain);
            } else {
                return filter.domain;
            }
        }

        function callbackMessage(error, data) {
            if (error) {
                return;
            }
            if (data.action.id === 'add') {
                msgService.addInfo('Filter added successfully');
            }
            if (data.action.id === 'delete') {
                msgService.addInfo('Filter deleted successfully');
            }
            if (data.action.id === 'edit') {
                msgService.addInfo('Filter edited successfully');
            }
        }
        function callback(error, data) {
            service.callbackMessage(error, data);
        }

        /**
         * @ngdoc method
         * @name setCollectionFilter
         * @methodOf swif.framework.swifFilterService
         * @description
         * Set the filter to the collection
         * @param {object} collection a swif.framework's collection
         * @param {object} filter the filter to apply
        **/
        function setCollectionFilter(collection, filter) {
            if (_.isString(filter)) {
                var domain = service.parseDomain(filter);
                dataService.setFilters(collection.currentFilter, domain);
            } else if (_.isObject(filter)) {
                if (_.isString(filter.domain)) {
                    filter.domain = service.parseDomain(filter);
                    collection.currentFilter.domain = filter.domain;
                } else {
                    collection.currentFilter = {
                        domain: filter.domain,
                        filters: filter.filters
                    };
                }
                if (filter.limit) {
                    collection.currentFilter.limit = filter.limit;
                }
                if (filter.sort) {
                    collection.currentFilter.sort = filter.sort;
                }
            }
        }

        /**
         * @ngdoc method
         * @name loadFilteredCollection
         * @methodOf swif.framework.swifFilterService
         * @description
         * Load a collection, apply a filter on it and display the right screen
         * @param {object} cid collection id
         * @param {object} action action
         * @param {object} filter the filter to apply
         **/
        function loadFilteredCollection(cid, action, filter) {
            var collection = collections.getCollection(cid);
            if ($location.path() === action.link) {
                // same screen
                setCollectionFilter(collection, filter);
                collection.updateLocation();
            } else {
                // screen change
                if (!collection) {
                    var prefix = 'c:' + cid;
                    $location.path(action.link);
                    $location.search(prefix, JSON.stringify(filter));
                } else {
                    //we already have a loaded collection, but we want to change the filter
                    collection.currentFilter = filter;
                    $location.path(action.link);
                    $location.search('doNotUpdateCollectionFilter', true);
                }
            }
        }
    }
})();
